import { IDs } from './IDs';

export function getVeranstaltungen(data: any): any[] {
    const hasVeranstaltungen: boolean = +data?.[IDs.ENT_KONFIGURATION]?.[0]?.veranstaltungen_orig === 1;
    const standorttypen: number[] = [5, 6]; // Veranstaltungen

    return ((data || {})[IDs.ENT_STANDORT] || [])
        .filter((standort: any) =>
            hasVeranstaltungen
            && ((+standort.energiedaten_erfassen_orig || +standort.energiedaten_erfassen) === 1)
            && ((typeof standort.standort_typ_tid_orig === 'number' && standorttypen.indexOf(standort.standort_typ_tid_orig) !== -1)
                || (typeof standort.standort_typ_tid === 'number' && standorttypen.indexOf(standort.standort_typ_tid) !== -1)
            )
        )
        .sort((a: any, b: any) => (+(+a.standort_typ_tid_orig !== 1) - +(+b.standort_typ_tid_orig !== 1)) || (a.name > b.name));
}

export function isVeranstaltung(data: any, tid: number): boolean {
    return [5, 6].indexOf((((data || {})[IDs.ENT_STANDORT] || []).find((item: any) => item.tid === tid) || {}).standort_typ_tid_orig) !== -1;
}
